/**
 *授权用户
 *@author xujinjiang
 *@date 2022/3/1 17:37
 */
import { AuthorizationUserServiceImpl } from '@/service/AuthorizationUserServiceImpl';
import { BaseViewModel } from '@/viewmodel/BaseViewModel';
import { ref } from 'vue';
import { UrlConfig } from '@/config/UrlConfig';
import { ObserverService } from '@/service/ObserverService';
import { CommonUtil } from '@/utils/CommonUtil';
import { RouterUtil } from '@/utils/RouterUtil';
import { LocalStorageManager } from '@/db/LocalStorageManager';

export class AuthorizationUserViewModel extends BaseViewModel {
  private userSubscription: any;
  isGetAllList = false;
  private authorizationUserList: any = []; // 授权用户列表
  private orgName = '';
  private orgId = '';
  inputValue: any = '';
  openId: any = '';
  conditionCode = '1';
  pageNo = 1;
  pageSize = 20;
  totalCount = 0;
  private dialogTableVisible = false;
  rowIndex: any;
  userLogList = []; // 用户日志列表
  isGetLogList = false;

  value: any = ref('');
  private startDate = '';
  private endDate = '';
  logPageNo = 1;
  logPageSize = 20;
  logTotalCount = 0;
  userId = '';
  showDatePicker = false;

  showPage = false;
  pageLoading: any;
  logLoading: any;
  userTableHeight = window.innerHeight - 410;
  isSearch = false;
  isSearchLog = false;

  mounted() {
    this.isSearch = false;
    this.pageLoading = CommonUtil.loading('.el-authorization-main');
    this.getParams();
    this.initObserver();
    window.addEventListener('resize', () => {
      this.userTableHeight = window.innerHeight - 410;
    });
  }

  unmounted() {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }

  private initObserver() {
    this.userSubscription = ObserverService.getInstance()
      .getUserObserver()
      .subscribe((userInfo: any) => {
        if (!userInfo) {
          return;
        }
        this.user = userInfo;
        this.getUserList().then(() => {
          this.isGetAllList = true;
          if (this.authorizationUserList.length > 0) {
            this.isSearch = true;
          }
        });
      });
  }

  private getParams() {
    const params = this.$route.query;
    if (!params || Object.keys(params).length === 0) {
      return;
    }
    this.conditionCode = '2';
    this.inputValue = params.id;
  }

  changeCondition() {
    this.inputValue = '';
  }

  search() {
    this.isSearch = true;
    this.getUserList().then();
  }

  /**
   * 获取授权用户列表
   */
  private async getUserList() {
    if (this.conditionCode === '1') {
      this.orgName = this.inputValue;
      this.orgId = '';
    } else {
      this.orgId = this.inputValue;
      this.orgName = '';
    }
    try {
      const result = await AuthorizationUserServiceImpl.getInstance().getAuthorizationUserList(
        this.user.id,
        this.orgId,
        this.orgName,
        this.openId,
        this.pageNo,
        this.pageSize
      );
      this.authorizationUserList = result.result;
      this.totalCount = result.totalCount;
      this.pageLoading.close();
      this.showPage = true;
    } catch (e) {
      console.error('获取授权用户列表失败：', e);
      this.isGetAllList = true;
      this.pageLoading.close();
    }
  }

  /**
   * 获取用户日志
   */
  private async getUserLogList(pageIndex?: any) {
    if (this.isSearchLog) {
      return;
    }
    this.isSearchLog = true;
    this.logLoading = CommonUtil.loading('.log-table');
    this.pageNo = pageIndex ? pageIndex : this.pageNo;
    this.startDate = this.startDate ? this.startDate : '';
    this.endDate = this.endDate ? this.endDate : '';
    try {
      const result: any = await AuthorizationUserServiceImpl.getInstance().getUserLogList(
        this.userId,
        this.startDate,
        this.endDate,
        this.logPageNo,
        this.logPageSize
      );
      this.logLoading.close();
      this.isSearchLog = false;
      this.userLogList = result.data.result;
      this.logTotalCount = result.data.totalCount;
    } catch (e) {
      console.error('获取用户日志列表失败：', e);
      this.logLoading.close();
      this.isGetLogList = true;
      this.isSearchLog = false;
    }
  }

  /**
   * 查看用户日志
   */
  async showLog(scrop: any) {
    this.startDate = '';
    this.endDate = '';
    this.value = [];
    this.userId = scrop.row.openId;
    this.dialogTableVisible = true;
  }

  getDaterange() {
    if (this.value) {
      this.startDate = CommonUtil.getDate(this.value[0]);
      this.endDate = CommonUtil.getDate(this.value[1]);
    } else {
      this.startDate = '';
      this.endDate = '';
    }
  }

  dialogOpened() {
    this.showDatePicker = true;
    this.getUserLogList(1).then(() => {
      this.isGetLogList = true;
    });
  }

  closeDialog() {
    this.showDatePicker = false;
    this.userLogList = [];
    this.isGetLogList = false;
  }

  /**
   * 打开开发与帮助文档
   */
  openDoc() {
    RouterUtil.openDocUser(this.$router);
  }

  async change(data: any) {
    this.pageNo = data.pageNo;
    this.pageSize = data.pageSize;
    await this.getUserList();
  }

  async logListchange(data: any) {
    this.logPageNo = data.pageNo;
    this.logPageSize = data.pageSize;
    await this.getUserLogList();
  }

  previewComponent(scop: any) {
    const bizId = scop.row.bizId;
    const token = LocalStorageManager.getItem('token');
    window.open(`${UrlConfig.playComponent}${bizId}?token=${token}`);
  }
  getIp(scop: any) {
    return scop.row.ipAddr.indexOf(',') > 0
      ? scop.row.ipAddr.substring(0, scop.row.ipAddr.indexOf(','))
      : scop.row.ipAddr;
  }

  getAddress(data: any) {
    const address = CommonUtil.checkEmpetyProvince(data.province, data.city, data.area);
    return address;
  }
}
